import { GetApiTokenListParams } from "@bvhi/backend-api/apis/model/getApiTokenListParams";
import { createFileRoute } from "@tanstack/react-router";
import { WithErrorBoundary } from "../../../hoc/with-error-boundary";
import { withPermissionCheck } from "../../../hoc/with-permission-check";
import { ApiTokenListView } from "../../../views/app/api-token/list/api-token-list-view";

export const Route = createFileRoute("/_main/app/api-token/")({
  validateSearch: (search: Record<string, unknown>): GetApiTokenListParams => {
    return {
      page: Number(search?.page ?? 0),
      size: Number(search?.size ?? 25),
    };
  },
  component: () => WithErrorBoundary({ Component: withPermissionCheck({ Component: ApiTokenListView }) }),
});
